<template>
    <div>
        <default-navigation navbarClass="bg-primary" ref="navigation"></default-navigation>
        <section class="bg-primary pt-0">
            <div class="custom-container">
                <div class="row justify-content-center">
                    <div class="col-xl-8 text-center">
                        <h1 class="mb-4">Overzicht van de resultaten</h1>
                        <div class="progress">
                            <div class="progress-bar bg-success color-white" role="progressbar" :style="'width: ' + percentageResponders + '%'" :aria-valuenow="percentageResponders" aria-valuemin="0"
                                 aria-valuemax="100">
                                {{ amountResponders }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="pt-0 pb-5 min-margin">
            <div class="custom-container">
                <div class="row justify-content-center">
                    <div class="col-xl-6">
                        <div class="form-floating">
                            <select class="form-select" id="selectedInquiry" v-model="selectedInquiry" aria-label="Floating label select example">
                                <option>Selecteer een onderzoek...</option>
                                <option v-for="item in inquiries" :value="item">{{ item.department }}, uiterste inleverdatum: {{ formatDate(item.deadline) }}</option>
                            </select>
                            <label for="selectedInquiry">Welk onderzoek wilt u analyseren?</label>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="pt-0 d-flex align-items-center justify-content-center" v-if="this.loading === true">
            <i class="fad fa-circle-notch fa-spin fa-4x color-primary"></i>
        </section>
        <section class="pt-0" v-if="this.loading === false">
            <div class="custom-container">
                <div class="row justify-content-center">
                    <div class="col-xl-8 text-center">
                        <span class="text-uppercase sub-sub bold">Kies een weergave</span>
                        <ul class="nav nav-pills mb-3 text-center justify-content-center" id="pills-tab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                                        aria-selected="true">Grafieken
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
                                        aria-selected="false">Tabel - gemiddelden
                                </button>
                            </li>
                        </ul>
                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <ResultChartRadar :answers="answers" />
                                    </div>
                                    <div class="col-lg-6">
                                        <ResultChartPolar :answers="answers" />
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade show active" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                                <table class="table text-start">
                                    <thead class="table-primary pt-4 pb-4">
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Vraag</th>
                                        <th scope="col">Score</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <th scope="row">1</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(1.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(1.1))">{{ getAverageScoreInPercentage(1.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">2</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(2.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(2.1))">{{ getAverageScoreInPercentage(2.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">3</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(3.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(3.1))">{{ getAverageScoreInPercentage(3.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">4</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(4.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(4.1))">{{ getAverageScoreInPercentage(4.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">5</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(5.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(5.1))">{{ getAverageScoreInPercentage(5.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">6</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(6.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(6.1))">{{ getAverageScoreInPercentage(6.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">7</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(7.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(7.1))">{{ getAverageScoreInPercentage(7.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">8</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(8.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(8.1))">{{ getAverageScoreInPercentage(8.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">9</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(9.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(9.1))">{{ getAverageScoreInPercentage(9.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">10</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(10.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(10.1))">{{ getAverageScoreInPercentage(10.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">11</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(11.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(11.1))">{{ getAverageScoreInPercentage(11.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">12</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(12.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(12.1))">{{ getAverageScoreInPercentage(12.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">13</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(13.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(13.1))">{{ getAverageScoreInPercentage(13.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">14</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(14.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(14.1))">{{ getAverageScoreInPercentage(14.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">15</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(15.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(15.1))">{{ getAverageScoreInPercentage(15.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">16</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(16.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(16.1))">{{ getAverageScoreInPercentage(16.1) }}%</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">17</th>
                                        <td>{{ QuestionRepository.getQuestionValueById(17.1) }}</td>
                                        <td><span :class="'badge ' + defineClassColor(getAverageScoreInPercentage(17.1))">{{ getAverageScoreInPercentage(17.1) }}%</span></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg-secondary" v-if="this.loading === false">
            <div class="custom-container">
                <div class="row">
                    <div class="col-xl-6">
                        <div class="form-floating mb-5">
                            <select v-model="selectedQuestion" id="selectedQuestion" class="form-select" aria-label="Floating label select example">
                                <option v-for="(question, i) in QuestionRepository.getFirstQuestions()" :value="question.id">{{ i + 1 }}. {{ question.question }}</option>
                            </select>
                            <label for="selectedQuestion">Toelichting bij vraag...</label>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="this.selectedQuestion !== null">
                    <div class="col-xl-8">
                        <table class="table text-start bg-white">
                            <thead class="table-primary pt-4 pb-4">
                            <tr>
                                <th scope="col">Ja / Nee</th>
                                <th scope="col" v-for="question in subQuestionsBySelectedQuestion.slice(1)">{{ question.question }}</th>
                                <th scope="col">Score</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="AnswerRepository in answers">
                                <template v-for="(question, index) in subQuestionsBySelectedQuestion">
                                    <td>
                                        <span :class="((index === 0) ? (AnswerRepository.getAnswerById(question.id) === 'ja' ? 'badge bg-danger' : 'badge bg-success' ) : '')">
                                            {{ AnswerRepository.getAnswerById(question.id) }}
                                        </span>
                                    </td>
                                    <td v-if="index + 1 === subQuestionsBySelectedQuestion.length">
                                        <span
                                            :class="'badge rounded-circle p-2 ' + defineClassColorByScore(AnswerRepository.getScoreForHeadId(parseFloat(String(question.id).substring(0, 2)) + .1))"><span
                                            class="visually-hidden">&nbsp;</span></span>
                                    </td>
                                </template>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-xl-3 ms-auto">
                        <div class="bg-primary rounded shadow-sm p-4">
                            <h5 class="mb-3">Tips en handige links</h5>
                            <a href="https://www.betermetarbo.nl/risicos/fysieke-belasting/" target="_blank" class="btn-outline">Arbocatalogus Ziekenhuizen</a>
                            <a href="https://www.dokterhoe.nl/risicos/fysieke-belasting/" target="_blank" class="btn-outline">Arbocatalogus Universitaire medische centra</a>
                            <a href="https://www.arbocatalogusgehandicaptenzorg.nl" target="_blank" class="btn-outline">Arbocatalogus Gehandicaptenzorg</a>
                            <a href="https://www.blijfinzetbaar.nl/werkomstandigheden-cultuur/fysieke-belasting/" target="_blank" class="btn-outline">Gezond & Zeker</a>
                            <a href="https://goedgebruik.nl/filmpjes-van-alle-technieken/13-praktijkrichtlijnen-niet-clientgebonden-activiteiten" target="_blank" class="btn-outline">GoedGebruik</a>
                            <a href="https://www.ergonomiesite.be/kim-tillen/" target="_blank" class="btn-outline">KIM</a>
                            <a href="https://www.leerstand.nl/ondersteunende-dienst" target="_blank" class="btn-outline">Leerstand</a>
                            <a href="https://www.arbobondgenoten.nl/arbothem/lichblst/lift.htm" target="_blank" class="btn-outline">NIOSH</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import {DateTime} from "luxon";
import QuestionRepository from "../../../repositories/QuestionRepository";
import AnswerRepository from "../../../repositories/AnswerRepository";
import InquiryService from '../../../services/InquiryService';
import ResultChartRadar from './Components/ResultChartRadar';
import ResultChartPolar from './Components/ResultChartPolar';

export default {
    name:       'ViewResults',
    components: {
        ResultChartRadar,
        ResultChartPolar
    },
    data() {
        return {
            user:                           null,
            error:                          null,
            inquiries:                      [],
            loading:                        false,
            selectedInquiry:                null,
            selectedQuestion:               null,
            answersBySelectedQuestion:      [],
            subQuestionsBySelectedQuestion: [],
            answers:                        [],
            amountResponders:               '',
            percentageResponders:           0,
            QuestionRepository:             new QuestionRepository(),
        }
    },
    watch: {
        selectedQuestion(question) {
            this.subQuestionsBySelectedQuestion = this.QuestionRepository.getAllQuestionsStartingWith(
                String(question).slice(0, -1)
            );
        },
        selectedInquiry(inquiry) {
            this.loading               = true;
            this.answers               = [];
            this.selectedQuestion      = 1.1;
            this.amountResponders      = inquiry.amountResponders + ' van de ' + inquiry.amountRecipients + ' hebben gereageerd'
            const percentageResponders = parseFloat(inquiry.amountResponders / inquiry.amountRecipients * 100);
            this.percentageResponders  = !isNaN(percentageResponders) ? percentageResponders : 0;

            const vm = this;

            InquiryService.getAnswersByInquiryId(this.$route.params.token, inquiry.id).then((response) => {
                if(response.data) {
                    for(const item of response.data.map((items) => items.results)) {
                        vm.answers.push(
                            new AnswerRepository(item)
                        )
                    }
                }
            }).finally(() => {
                vm.loading = false;
            });
        }
    },
    beforeRouteEnter(to, from, next) {
        InquiryService.getInquiries(to.params.token).then(({ user, inquiries }) => {
            if(!user) {
                throw 'User not found';
            }

            next((vm) => {
                vm.user      = user;
                vm.inquiries = inquiries.filter((item) => item.sent !== null);
            });
        }).catch((error) => {
            next({ path: '/' });
        });
    },
    methods: {
        formatDate(date) {
            return DateTime.fromJSDate(new Date(date)).setLocale('nl').toFormat('dd LLL yyyy');
        },

        getAverageScoreInPercentage(questionId) {
            const total = this.answers.reduce((previousValue, AnswerRepository) => AnswerRepository.getScoreForHeadId(questionId) + previousValue, 0);

            if(total === 0) {
                return 0;
            }

            return (total / this.answers.length) * 100;
        },

        defineClassColor(percentage) {
            if(percentage >= 0 && percentage <= 40) {
                return 'bg-danger';
            }

            if(percentage > 40 && percentage <= 70) {
                return 'bg-warning';
            }

            if(percentage > 70) {
                return 'bg-success';
            }
        },

        defineClassColorByScore(score) {
            if(score === 1) {
                return 'bg-success';
            }

            if(score === 0.5) {
                return 'bg-warning';
            }

            return 'bg-danger';
        }
    },
    created() {
        Vue.nextTick(() => {
            if(this.$route.query.select) {
                this.selectedInquiry = this.inquiries.find((inquiry) => inquiry.id === this.$route.query.select);
            }
        });
    },
    mounted() {
        this.$refs.navigation.$data.showButton = true;
    }
}
</script>
